/* =========================================================
   SSSS Gallery — global behaviour
   ========================================================= */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const S = window.SSSS || {};
  const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- helpers ---------- */
  const money = (cents) => {
    const fmt = S.money || '${{amount}}';
    const v = (cents / 100);
    const withDelims = (n, d = 2, t = ',', dec = '.') => {
      const [a, b] = n.toFixed(d).split('.');
      return a.replace(/\B(?=(\d{3})+(?!\d))/g, t) + (d ? dec + b : '');
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) => {
      switch (k) {
        case 'amount_no_decimals': return withDelims(v, 0);
        case 'amount_with_comma_separator': return withDelims(v, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(v, 0, '.', ',');
        default: return withDelims(v, 2);
      }
    });
  };
  let toastTimer;
  const toast = (msg) => {
    const t = $('.toast'); if (!t) return;
    t.textContent = msg; t.hidden = false;
    t.style.animation = 'none'; t.offsetHeight; t.style.animation = '';
    clearTimeout(toastTimer); toastTimer = setTimeout(() => (t.hidden = true), 2600);
  };
  const lock = (on) => document.body.classList.toggle('is-locked', on);
  const emit = (el) => el && el.dispatchEvent(new CustomEvent('ssss:content', { bubbles: true }));
  window.SSSSUtil = { money, toast };

  /* ---------- reveal on scroll ---------- */
  const revealIO = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
    entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-in'); revealIO.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }) : null;
  const scanReveal = (root = document) => {
    $$('[data-reveal]:not(.is-in)', root).forEach((el) => revealIO ? revealIO.observe(el) : el.classList.add('is-in'));
  };

  /* ---------- count up ---------- */
  const countIO = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      if (!e.isIntersecting) return;
      countIO.unobserve(e.target);
      const el = e.target, end = parseFloat(el.dataset.countUp), dur = 1400, t0 = performance.now();
      const suffix = el.dataset.suffix || '';
      if (reduceMotion) { el.textContent = end.toLocaleString() + suffix; return; }
      const step = (now) => {
        const t = Math.min(1, (now - t0) / dur), v = Math.round(end * (1 - Math.pow(1 - t, 3)));
        el.textContent = v.toLocaleString() + suffix;
        if (t < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    });
  }, { threshold: 0.4 });
  const scanCount = (root = document) => $$('[data-count-up]', root).forEach((el) => countIO.observe(el));

  /* ---------- magnetic ---------- */
  const scanMagnetic = (root = document) => {
    if (reduceMotion || !matchMedia('(hover: hover)').matches) return;
    $$('[data-magnetic]', root).forEach((el) => {
      if (el._mag) return; el._mag = true;
      el.addEventListener('pointermove', (e) => {
        const r = el.getBoundingClientRect();
        const x = (e.clientX - r.left - r.width / 2) * 0.22, y = (e.clientY - r.top - r.height / 2) * 0.32;
        el.style.transform = `translate(${x}px, ${y}px)`;
      });
      el.addEventListener('pointerleave', () => { el.style.transform = ''; });
    });
  };

  /* ---------- rails ---------- */
  const scanRails = (root = document) => {
    $$('[data-rail]', root).forEach((wrap) => {
      if (wrap._rail) return; wrap._rail = true;
      const rail = $('.rail', wrap), prev = $('[data-rail-prev]', wrap), next = $('[data-rail-next]', wrap);
      if (!rail) return;
      const upd = () => {
        if (prev) prev.disabled = rail.scrollLeft < 8;
        if (next) next.disabled = rail.scrollLeft + rail.clientWidth > rail.scrollWidth - 8;
      };
      const by = () => rail.clientWidth * 0.8;
      prev && prev.addEventListener('click', () => rail.scrollBy({ left: -by(), behavior: 'smooth' }));
      next && next.addEventListener('click', () => rail.scrollBy({ left: by(), behavior: 'smooth' }));
      rail.addEventListener('scroll', upd, { passive: true }); upd();
    });
  };

  const scanAll = (root = document) => { scanReveal(root); scanCount(root); scanMagnetic(root); scanRails(root); };
  document.addEventListener('ssss:content', (e) => scanAll(e.target));
  document.addEventListener('shopify:section:load', (e) => scanAll(e.target));

  /* ---------- header ---------- */
  function initHeader() {
    const header = $('.header'); if (!header) return;
    let lastY = scrollY;
    const onScroll = () => {
      const y = scrollY;
      header.classList.toggle('is-scrolled', y > 10);
      const megaOpen = $('.nav__item.is-open');
      if (!megaOpen && y > 400 && y > lastY + 6) header.classList.add('is-hidden');
      else if (y < lastY - 6 || y < 400) header.classList.remove('is-hidden');
      lastY = y;
    };
    addEventListener('scroll', onScroll, { passive: true }); onScroll();

    $$('.nav__item[data-mega]', header).forEach((item) => {
      let t;
      const open = () => { clearTimeout(t); $$('.nav__item.is-open', header).forEach((o) => o !== item && o.classList.remove('is-open')); item.classList.add('is-open'); item.querySelector('.nav__link')?.setAttribute('aria-expanded', 'true'); };
      const close = () => { t = setTimeout(() => { item.classList.remove('is-open'); item.querySelector('.nav__link')?.setAttribute('aria-expanded', 'false'); }, 140); };
      item.addEventListener('pointerenter', (e) => e.pointerType === 'mouse' && open());
      item.addEventListener('pointerleave', (e) => e.pointerType === 'mouse' && close());
      item.addEventListener('focusin', open);
      item.addEventListener('focusout', (e) => { if (!item.contains(e.relatedTarget)) close(); });
      item.addEventListener('keydown', (e) => { if (e.key === 'Escape') { item.classList.remove('is-open'); item.querySelector('.nav__link')?.focus(); } });
    });

    const dn = $('.drawer-nav');
    $$('[data-open-menu]').forEach((b) => b.addEventListener('click', () => { dn.classList.add('is-open'); lock(true); dn.querySelector('button')?.focus(); }));
    $$('[data-close-menu]').forEach((b) => b.addEventListener('click', () => { dn.classList.remove('is-open'); lock(false); }));
  }

  /* ---------- age gate ---------- */
  function initAge() {
    const gate = $('.age'); if (!gate) return;
    let ok = false;
    try { ok = localStorage.getItem('ssss-age-ok') === '1'; } catch (e) {}
    if (ok || /bot|crawl|spider|lighthouse/i.test(navigator.userAgent)) { gate.remove(); return; }
    gate.hidden = false; lock(true);
    $('[data-age-yes]', gate).addEventListener('click', () => {
      try { localStorage.setItem('ssss-age-ok', '1'); } catch (e) {}
      gate.classList.add('is-leaving'); lock(false);
      setTimeout(() => gate.remove(), 650);
    });
  }

  /* =========================================================
     Cart
     ========================================================= */
  const Cart = {
    drawer: null,
    sections() { return ['cart-drawer'].filter((id) => document.getElementById('shopify-section-' + id)); },
    open() {
      this.drawer = this.drawer || $('#CartDrawer');
      if (!this.drawer) { location.href = S.routes.cart; return; }
      this.drawer.classList.add('is-open'); lock(true);
      setTimeout(() => $('.drawer__head button', this.drawer)?.focus(), 50);
    },
    close() { this.drawer?.classList.remove('is-open'); lock(false); },
    apply(sections) {
      if (!sections) return;
      Object.entries(sections).forEach(([id, html]) => {
        const host = document.getElementById('shopify-section-' + id);
        if (!host || !html) return;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.getElementById('shopify-section-' + id) || doc.body.firstElementChild;
        if (id === 'cart-drawer') {
          const body = $('[data-cart-inner]', host), nb = $('[data-cart-inner]', fresh);
          if (body && nb) body.replaceWith(nb); else host.innerHTML = fresh.innerHTML;
        } else host.innerHTML = fresh.innerHTML;
      });
      const src = $('[data-cart-count]');
      $$('.cart-count').forEach((c) => {
        if (src) { c.textContent = src.dataset.cartCount; c.dataset.count = src.dataset.cartCount; }
        c.classList.remove('is-bump'); c.offsetWidth; c.classList.add('is-bump');
      });
      emit($('#CartDrawer'));
    },
    async add(items, btn) {
      btn && btn.classList.add('is-loading');
      try {
        const res = await fetch(S.routes.cartAdd + '.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items, sections: this.sections(), sections_url: location.pathname })
        });
        const data = await res.json();
        if (!res.ok || data.status) throw new Error(data.description || data.message || 'Could not add to cart');
        this.apply(data.sections);
        this.open();
        return data;
      } catch (err) {
        toast(err.message || 'Something went wrong');
        throw err;
      } finally { btn && btn.classList.remove('is-loading'); }
    },
    async change(line, quantity) {
      const row = $(`[data-line="${line}"]`); row && row.classList.add('is-updating');
      try {
        const res = await fetch(S.routes.cartChange + '.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line, quantity, sections: this.sections(), sections_url: location.pathname })
        });
        const data = await res.json();
        if (!res.ok || data.status) throw new Error(data.description || data.message);
        this.apply(data.sections);
        if (S.template === 'cart') location.reload();
      } catch (err) { toast(err.message || 'Could not update cart'); row && row.classList.remove('is-updating'); }
    }
  };
  window.SSSSCart = Cart;

  function initCart() {
    document.addEventListener('click', (e) => {
      const opener = e.target.closest('[data-open-cart]');
      if (opener) { e.preventDefault(); Cart.open(); return; }
      if (e.target.closest('[data-close-cart]')) { Cart.close(); return; }

      const quick = e.target.closest('[data-quick-add]');
      if (quick) {
        e.preventDefault();
        Cart.add([{ id: Number(quick.dataset.quickAdd), quantity: 1 }], quick).then(() => {
          quick.classList.add('is-added'); setTimeout(() => quick.classList.remove('is-added'), 1600);
        }).catch(() => {});
        return;
      }
      const q = e.target.closest('[data-qty]');
      if (q) {
        const line = Number(q.closest('[data-line]').dataset.line);
        const input = q.closest('.qty').querySelector('input');
        const v = Math.max(0, Number(input.value) + Number(q.dataset.qty));
        input.value = v; Cart.change(line, v); return;
      }
      const rm = e.target.closest('[data-remove]');
      if (rm) { e.preventDefault(); Cart.change(Number(rm.closest('[data-line]').dataset.line), 0); }
    });
    document.addEventListener('change', (e) => {
      const input = e.target.closest('.qty input');
      if (input && input.closest('[data-line]')) Cart.change(Number(input.closest('[data-line]').dataset.line), Math.max(0, Number(input.value)));
    });
    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      Cart.close(); Search.close();
      const dn = $('.drawer-nav.is-open'); if (dn) { dn.classList.remove('is-open'); lock(false); }
      const fd = $('.filters.is-open'); if (fd) { fd.classList.remove('is-open'); lock(false); }
    });

    // Product forms
    document.addEventListener('submit', (e) => {
      const form = e.target.closest('form[data-product-form]');
      if (!form) return;
      e.preventDefault();
      const fd = new FormData(form);
      const btn = form.querySelector('[type="submit"]');
      const props = {};
      for (const [k, v] of fd.entries()) { const m = k.match(/^properties\[(.+)\]$/); if (m && v) props[m[1]] = v; }
      Cart.add([{ id: Number(fd.get('id')), quantity: Number(fd.get('quantity') || 1), properties: props }], btn).catch(() => {});
    });
  }

  /* =========================================================
     Predictive search
     ========================================================= */
  const Search = {
    el: null, input: null, results: null, ctrl: null, t: null,
    init() {
      this.el = $('#SearchOverlay'); if (!this.el) return;
      this.input = $('.search__input', this.el); this.results = $('[data-search-results]', this.el);
      this.defaults = $('[data-search-defaults]', this.el);
      $$('[data-open-search]').forEach((b) => b.addEventListener('click', (e) => { e.preventDefault(); this.open(); }));
      $$('[data-close-search]', this.el).forEach((b) => b.addEventListener('click', () => this.close()));
      this.input.addEventListener('input', () => { clearTimeout(this.t); this.t = setTimeout(() => this.query(), 180); });
      document.addEventListener('keydown', (e) => {
        if ((e.key === '/' || (e.key === 'k' && (e.metaKey || e.ctrlKey))) && !/input|textarea|select/i.test(document.activeElement.tagName)) { e.preventDefault(); this.open(); }
      });
    },
    open() { if (!this.el) return; this.el.classList.add('is-open'); lock(true); setTimeout(() => this.input.focus(), 60); },
    close() { if (!this.el || !this.el.classList.contains('is-open')) return; this.el.classList.remove('is-open'); lock(false); },
    async query() {
      const q = this.input.value.trim();
      if (q.length < 2) { this.results.innerHTML = ''; this.defaults.hidden = false; return; }
      this.ctrl && this.ctrl.abort(); this.ctrl = new AbortController();
      try {
        const url = `${S.routes.predictive}?q=${encodeURIComponent(q)}&resources[type]=product,collection,query&resources[limit]=8&resources[options][unavailable_products]=last&section_id=predictive-search`;
        const res = await fetch(url, { signal: this.ctrl.signal });
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const inner = doc.querySelector('[data-predictive]');
        this.defaults.hidden = true;
        this.results.innerHTML = inner ? inner.innerHTML : '';
        emit(this.results);
      } catch (e) { /* aborted */ }
    }
  };

  /* =========================================================
     Collection: filters, density, load more
     ========================================================= */
  function initCollection() {
    const root = $('[data-collection]'); if (!root) return;
    const sectionId = root.dataset.sectionId;

    const fetchSection = async (url, mode = 'replace') => {
      root.classList.add('is-loading');
      const u = new URL(url, location.origin); u.searchParams.set('section_id', sectionId);
      const html = await (await fetch(u)).text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      if (mode === 'append') {
        const grid = $('[data-grid]', root), ng = $('[data-grid]', doc);
        const added = [...ng.children]; added.forEach((c, i) => { c.style.setProperty('--i', i % 8); grid.appendChild(c); });
        const lm = $('[data-load-more-wrap]', root), nlm = $('[data-load-more-wrap]', doc);
        if (lm) nlm ? lm.replaceWith(nlm) : lm.remove();
      } else {
        ['[data-results]', '[data-filters-body]', '[data-active-filters]', '[data-toolbar]'].forEach((sel) => {
          const a = $(sel, root), b = $(sel, doc); if (a && b) a.replaceWith(b);
        });
        applyDensity();
      }
      root.classList.remove('is-loading');
      emit(root);
    };

    // Filters change -> fetch
    root.addEventListener('change', (e) => {
      const form = e.target.closest('form[data-filter-form]'); if (!form) return;
      if (e.target.closest('[data-price-input]')) return;
      submitFilters(form);
    });
    root.addEventListener('submit', (e) => {
      const form = e.target.closest('form[data-filter-form]'); if (!form) return;
      e.preventDefault(); submitFilters(form);
    });
    const submitFilters = (form) => {
      const params = new URLSearchParams(new FormData(form));
      [...params.keys()].forEach((k) => { if (!params.get(k)) params.delete(k); });
      const sort = $('[data-sort]', root); if (sort && sort.value) params.set('sort_by', sort.value);
      const url = location.pathname + '?' + params.toString();
      history.replaceState({}, '', url);
      fetchSection(url);
    };
    root.addEventListener('click', (e) => {
      const a = e.target.closest('a[data-filter-link]');
      if (a) {
        e.preventDefault();
        if (a.dataset.showSold !== undefined) { try { sessionStorage.setItem('ssss-show-sold', a.dataset.showSold); } catch (err) {} }
        history.replaceState({}, '', a.href); fetchSection(a.href);
        return;
      }
      const more = e.target.closest('[data-load-more]');
      if (more) { e.preventDefault(); more.classList.add('is-loading'); fetchSection(more.href, 'append'); return; }
      const dens = e.target.closest('[data-density-btn]');
      if (dens) {
        const v = dens.dataset.densityBtn; $('[data-grid]', root).dataset.density = v;
        $$('[data-density-btn]', root).forEach((b) => b.setAttribute('aria-pressed', String(b === dens)));
        try { localStorage.setItem('ssss-density', v); } catch (err) {}
        return;
      }
      if (e.target.closest('[data-open-filters]')) { $('.filters', root).classList.add('is-open'); lock(true); }
      if (e.target.closest('[data-close-filters]')) { $('.filters', root).classList.remove('is-open'); lock(false); }
    });
    root.addEventListener('change', (e) => {
      const sort = e.target.closest('[data-sort]'); if (!sort) return;
      const u = new URL(location.href); u.searchParams.set('sort_by', sort.value); u.searchParams.delete('page');
      history.replaceState({}, '', u); fetchSection(u.toString());
    });
    function applyDensity() {
      try { const d = localStorage.getItem('ssss-density'); if (d) { const g = $('[data-grid]', root); if (g) g.dataset.density = d; $$('[data-density-btn]', root).forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.densityBtn === d))); } } catch (e) {}
    }
    applyDensity();

    // Infinite load when the load-more button nears the viewport
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => {
        const btn = en.target.querySelector('[data-load-more]');
        if (en.isIntersecting && btn && !btn.classList.contains('is-loading') && root.dataset.auto !== 'false') btn.click();
      });
    }, { rootMargin: '600px' });
    const watch = () => { const w = $('[data-load-more-wrap]', root); if (w && !w._w) { w._w = true; io.observe(w); } };
    watch(); root.addEventListener('ssss:content', watch);
  }

  /* =========================================================
     Boot
     ========================================================= */
  const boot = () => {
    initHeader(); initAge(); initCart(); Search.init(); initCollection();
    scanAll();
  };
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
})();
